import { useEffect, useRef, type FC } from 'react';

import { PromotionsCustomEvents, sendPromoEarRootMountEvent } from '../../promotionsV2/helper/customEvents';

import styles from './PromoEarPortalRoot.module.css';

export const PromoEarPortalRoot: FC = () => {
  const promoEarRootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleRequestPortal = (): void => {
      sendPromoEarRootMountEvent(promoEarRootRef.current);
    };

    window.addEventListener(PromotionsCustomEvents.OnPromoEarRootRequest, handleRequestPortal);

    sendPromoEarRootMountEvent(promoEarRootRef.current);

    return (): void => {
      window.removeEventListener(PromotionsCustomEvents.OnPromoEarRootRequest, handleRequestPortal);
    };
  }, []);

  return <div ref={promoEarRootRef} className={styles.promoEarRoot} />;
};
